import React, { useState } from 'react';
import Cropper from 'react-easy-crop';
import getCroppedImg from '../utils/cropImage';
import '../styles/ImageCropper.css';

const ImageCropper = ({ imageSrc, onCropComplete }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);

  const onCropCompleteCallback = async (croppedAreaPixels) => {
    if (!croppedAreaPixels) return;

    try {
      const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);
      onCropComplete(croppedImageBlob);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="cropper-container">
      <Cropper
        image={imageSrc}
        cropShape="round"
        crop={crop}
        zoom={zoom}
        aspect={1}
        onCropChange={setCrop}
        onZoomChange={setZoom}
        onCropComplete={(croppedArea, croppedAreaPixels) => {
          onCropCompleteCallback(croppedAreaPixels);
        }}
      />
      <div className="zoom-control">
        <input
          type="range"
          value={zoom}
          min="1"
          max="3"
          step="0.1"
          aria-labelledby="Zoom"
          onChange={(e) => setZoom(e.target.value)}
        />
      </div>
    </div>
  );
};

export default ImageCropper;
